import {ListItemText, Typography, MenuItem, Divider, Tooltip, Toolbar, AppBar, Button, Menu} from '@mui/material';
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import OfflineBoltOutlinedIcon from '@mui/icons-material/OfflineBoltOutlined';
import CenterFocusWeakIcon from '@mui/icons-material/CenterFocusWeak';
import MapOutlinedIcon from '@mui/icons-material/MapOutlined';
import FilterListIcon from '@mui/icons-material/FilterList';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import FunctionsIcon from '@mui/icons-material/Functions';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import HomeIcon from '@mui/icons-material/Home';
import MenuIcon from '@mui/icons-material/Menu';
import AddIcon from '@mui/icons-material/Add';
import {useTranslation} from "react-i18next";
import {useNavigate} from 'react-router';
import React, { useState } from 'react';
import {observer} from 'mobx-react';
import {TAB_TIME, TAB_LOCATION, TAB_SPEC, TAB_OTHER, TAB_YEAR, TAB_LIFER, TAB_LOC, TAB_ASSO, TAB_MONTH, TAB_TRIP, TAB_OBS, TAB_WINTER} from './stats/StatsCommon.js'
import {useGlobalStorage} from './mobx/GlobalStorage.js';
import {LIST_MAP_MAX_ELEM} from './ListMap.js';
import ConnLevelButton from './ConnLevel.js';
import PwdDialog from './PwdDialog.js';
import {EM_SELF} from './Util.js';

function LangMenu(props) {
	const {t, i18n} = useTranslation('obs');

	const setLang = (event) => {
		let lang = 'en';

		if (!event.target.value) {
			props._selected();
			return;
		}	
		
		if (event.target.value === 1) {
			lang = 'fi';
		} 

		i18n.changeLanguage(lang);
		window.localStorage.setItem('language', lang);
		props._selected();
	};

	return (
		<Menu
			anchorOrigin={{
				vertical: 'top',
				horizontal: 'right',
			}}
			transformOrigin={{
				vertical: 'top',
				horizontal: 'left',
			}}

			anchorEl={props.anchor}
			keepMounted
			open={Boolean(props.anchor)}
			onClose={setLang}>
			
			<MenuItem onClick={setLang} value={1}>{t('common.fi')}</MenuItem>
			<MenuItem onClick={setLang} value={2}>{t('common.en')}</MenuItem>
		</Menu>
	)
};

function UserMenu(props) {
	const [set_pwd_open, setSetPwdOpen] = useState(false);
	const gStorage = useGlobalStorage();
	const {t} = useTranslation('obs');
	const navigate = useNavigate();

	const openSettings = (event) => {
		gStorage.settings.setEditMode(EM_SELF);
		navigate('/settings');
		props._selected();
	}

	const logout = () => {
		let msg = {
			sess_id: gStorage.conn.sess_id,
			cmd: 'logout',
			data: {
				user: gStorage.conn.user,
			},
		}

		gStorage.conn.ws.send(msg);
		props._selected();
	}

	const openChangePassword = (event) => {
		props._selected();
		navigate('/pwd', { replace: true });
	}

	const passwdChanged = (event) => {
		setSetPwdOpen(false);
		props._selected();
	}

	const openLocations = (event) => {
		navigate('/locations');
		props._selected();
	}

	const openNotifications = (event) => {
		navigate('/notifications');
		props._selected();
	}

	const openNotificationList = (event) => {
		navigate('/notification_list');
		props._selected();
	}

	return (
		<div>
			<Menu
				anchorOrigin={{
					vertical: 'top',
					horizontal: 'right',
				}}
				transformOrigin={{
					vertical: 'top',
					horizontal: 'left',
				}}

				anchorEl={props.anchor}
				keepMounted
				open={Boolean(props.anchor)}
				onClose={props._selected}>

				{gStorage.conn.is_auth && gStorage.conn.online && window.location.pathname !== '/settings' ? <MenuItem onClick={openSettings}>{t('menu.settings')}</MenuItem> : null}
				{gStorage.conn.is_auth && gStorage.conn.online && window.location.pathname !== '/locations' ? <MenuItem onClick={openLocations}>{t('menu.locations')}</MenuItem> : null}
				{gStorage.conn.is_auth && gStorage.conn.online && window.location.pathname !== '/notifications' ? <MenuItem onClick={openNotifications}>{t('menu.notification_settings')}</MenuItem> : null}
				{gStorage.conn.is_auth && gStorage.conn.online && window.location.pathname !== '/notification_list' ? <MenuItem onClick={openNotificationList}>{t('menu.notification_list')}</MenuItem> : null}
				{gStorage.conn.is_auth && gStorage.conn.online ? <MenuItem onClick={openChangePassword}>{t('menu.change_passwd')}</MenuItem> : null}
				{gStorage.conn.is_auth && gStorage.conn.online ? <MenuItem onClick={logout}>{t('menu.logout')}</MenuItem> : null}
			</Menu>

			<PwdDialog set_open={set_pwd_open} onClose={passwdChanged} forced={false}/>
		</div>
	)
}

function AdminMenu(props) {
	const {t} = useTranslation('obs');
	const navigate = useNavigate();

	const adminOp = (op) => {
// 		console.log('adminOp:', op);
		if (!op) {
			props._selected();
			return 
		}	

		if (op === 1) {
			navigate('/users');
		} 

		props._selected();
	};

	return (
		<Menu
			anchorOrigin={{
				vertical: 'top',
				horizontal: 'right',
			}}
			transformOrigin={{
				vertical: 'top',
				horizontal: 'left',
			}}

			anchorEl={props.anchor}
			keepMounted
			open={Boolean(props.anchor)}
			onClose={adminOp}>
			
			<MenuItem onClick={adminOp.bind(this, 1)}>
				<ListItemText>
					{t('admin.users')}
				</ListItemText>
			</MenuItem>
		</Menu>
	)
};

const OnlineCheckBox = observer((props) => {
	const gStorage = useGlobalStorage();

	if (gStorage.conn.connected && gStorage.conn.online)
		return  (<div style={{color: 'green', fontWeight: 'bold'}}><span aria-label="green bulb" role="img">&#128161;</span></div>);

	return  (<div style={{color: 'red', fontWeight: 'bold'}}>
			<span aria-label="red bulb" role="img">
				{gStorage.conn.forcedOffline ? 'F ' : ''} &#128161;
			</span>
		</div>);
});


const ObsMenuBtn = observer(() => {
	const [adminAnchor, setAdminAnchor] = useState(null);
	const [langAnchor, setLangAnchor] = useState(null);
	const [userAnchor, setUserAnchor] = useState(null);
	const [anchorEl, setanchorEl] = useState(null);
	const navigate = useNavigate();

	const handleClick = (event) => setanchorEl(event.currentTarget);
	const handleClose = (event) => setanchorEl(null);

	const gStorage = useGlobalStorage();

	const openHome = (event) => {
		navigate('/', { replace: true });
		handleClose(event);
	}

	const openTaxons = (event) => {
		navigate('/taxons');
		handleClose(event);
	}

	const openTrips = (event) => {
		navigate('/trips');
		handleClose(event);
	}

	const openStats = (event) => {
		navigate('/statistics');
		handleClose(event);
	}

	const openDestinations = (event) => {
		navigate('/destlist');
		handleClose(event);
	}
	
	const openNavi = (event) => {
		navigate('/navi');
		handleClose(event);
	}

	const openCalendar = (event) => {
		navigate('/calendar');
		handleClose(event);
	}
	
	const openLangMenu = (event) => {
		setLangAnchor(event.currentTarget);
	}

	const langSelected = (event) => {
		setLangAnchor(null);
		handleClose(event);
	}

	const openAbout = (event) => {
		navigate('/about');
		handleClose(event);
	}

	const openUserMenu = (event) => {
		setUserAnchor(event.currentTarget);
	}

	const userSelected = (event) => {
		setUserAnchor(null);
		handleClose(event);
	}

	const openAdmin = (event) => {
		setAdminAnchor(event.currentTarget);
	}

	const adminSelected = (event) => {
		setAdminAnchor(null);
		handleClose(event);
	}

	function userMenuText() {
		if (!gStorage.conn.user.first_name && !gStorage.conn.user.last_name && !gStorage.conn.user.nick) 
			return '';

		if (gStorage.conn.user.first_name.length > 0 && gStorage.conn.user.last_name.length > 0)
			return gStorage.conn.user.first_name + ' ' + gStorage.conn.user.last_name;

		return gStorage.conn.user.nick;
	}

	function toggleOnline(ev) {
		if (gStorage.conn.connected) {
			const ol = gStorage.conn.online ? false : true;

			gStorage.conn.setOnline(ol, true);
			if (ol) {
				if (gStorage.conn.connected) {
					window.localStorage.setItem('forcedOffline', JSON.stringify(false));
				}
			} else {
				window.localStorage.setItem('forcedOffline', JSON.stringify(true));
			}
		} else {
			const newState = gStorage.conn.forcedOffline ? false : true;

			gStorage.conn.setForceOffline(newState);
			window.localStorage.setItem('forcedOffline', JSON.stringify(newState));
		}
		handleClose(ev);
	}

	const {t} = useTranslation('obs');

// 	console.log('menu: _access', gStorage.conn.user._access);

	return (
		<div>
			<Tooltip title={t('menu.menu')}>
				<IconButton edge="start" color="inherit" aria-label="menu" onClick={handleClick}>
					<MenuIcon />
				</IconButton>
			</Tooltip>

			<Menu sx={{ width: 320, maxWidth: '100%' }}
				anchorOrigin={{
					vertical: 'bottom',
					horizontal: 'left',
				}}
				transformOrigin={{
					vertical: 'top',
					horizontal: 'left',
				}}

				anchorEl={anchorEl}
				keepMounted
				open={Boolean(anchorEl)}
				onClose={handleClose}>

				{gStorage.conn.is_auth ? <MenuItem disabled={window.location.pathname === '/'} onClick={openHome}>{t('menu.home')}</MenuItem> : null}
				{gStorage.conn.is_auth && gStorage.conn.online ? <MenuItem disabled={window.location.pathname === '/statistics'} onClick={openStats}>{t('menu.stats')}</MenuItem> : null}
				{gStorage.conn.is_auth && gStorage.conn.online ? <MenuItem disabled={window.location.pathname === '/taxons'} onClick={openTaxons}>{t('taxons.taxons')}</MenuItem> : null}
				{gStorage.conn.is_auth && gStorage.conn.online ? <MenuItem disabled={window.location.pathname === '/trips'} onClick={openTrips}>{t('menu.trips')}</MenuItem> : null}
				{gStorage.conn.is_auth && gStorage.conn.online ? <MenuItem disabled={window.location.pathname === '/destlist'} onClick={openDestinations}>{t('menu.destinations')}</MenuItem> : null}
				{gStorage.conn.is_auth && gStorage.conn.online ? <MenuItem disabled={window.location.pathname === '/calendar'} onClick={openCalendar}>{t('menu.calendar')}</MenuItem> : null}
				{gStorage.conn.is_auth && gStorage.conn.online ? <MenuItem disabled={window.location.pathname === '/navi'} onClick={openNavi}>{t('menu.navi')}</MenuItem> : null}

				{gStorage.conn.is_auth && gStorage.conn.online ? <Divider /> : null}

				{gStorage.conn.is_auth ? 
					<MenuItem onClick={toggleOnline}>
						<ListItemText>
							{t('menu.online')}&nbsp;
						</ListItemText>
						<OnlineCheckBox/>
					</MenuItem> : 
					null}

				{ /* Language ------------------------------- */ }

				<MenuItem onClick={openLangMenu}>
					<ListItemText>
						{t('menu.language')}
					</ListItemText>
					<ArrowRightIcon/>
				</MenuItem>
				<MenuItem onClick={openAbout}>{t('menu.about')}</MenuItem>


				{ /* User ----------------------------------- */ }

				{gStorage.conn.is_auth && gStorage.conn.online ? <Divider /> : null}
				{gStorage.conn.is_auth && gStorage.conn.online ? 
					<MenuItem onClick={openUserMenu}>
						<ListItemText>
							{userMenuText()}
						</ListItemText>
						<ArrowRightIcon/>
					</MenuItem> : 
					null}

				{ /* Admin ---------------------------------- */ }

				{gStorage.conn.is_auth && gStorage.conn.online && gStorage.conn.user._access ? <Divider /> : null}
				{gStorage.conn.is_auth && gStorage.conn.online && gStorage.conn.user._access ? 
					<MenuItem onClick={openAdmin}>
						<ListItemText>
							{t('menu.admin')}
						</ListItemText>
						<ArrowRightIcon/>
					</MenuItem> : 
					null}

				{ /* Submenus ------------------------------- */ }

				<LangMenu anchor={langAnchor} _selected={langSelected} />
				<AdminMenu anchor={adminAnchor} _selected={adminSelected} />
				<UserMenu anchor={userAnchor} _selected={userSelected}/>
			</Menu>
		</div>
	)
});

const ObsAddBtn = observer((props) => {
	const gStorage = useGlobalStorage();
	const {t} = useTranslation('obs');
	
	if (!gStorage.conn.is_auth || (window.location.pathname !== '/' && !gStorage.conn.online) || props.action === undefined || props.action === null) 
		return null;

	const addColor = gStorage.conn.user.trip1 || gStorage.conn.user.trip2 || gStorage.conn.user.trip3 ? 'yellow' : 'inherit';

	return (
		<Tooltip title={t('menu.add')}>
			<IconButton size="small" sx={{color: addColor}} onClick={props.action}>
				<AddIcon/>
			</IconButton>
		</Tooltip>
	);
});

const ObsHomeBtn = observer((props) => {
	const gStorage = useGlobalStorage();
	const {t} = useTranslation('obs');

	if (!gStorage.conn.is_auth || window.location.pathname === '/' || window.location.pathname === '/settings') 
		return null;

	return (
		<Tooltip title={t('menu.home')}>
			<IconButton size="small" color="inherit" onClick={props.to_home}>				
				<HomeIcon />
			</IconButton>
		</Tooltip>
	);
});

const ObsNotificationBtn = observer((props) => {
	const gStorage = useGlobalStorage();
	const {t} = useTranslation('obs');

	if (!gStorage.conn.is_auth || !gStorage.conn.new_notifications)
		return null;

	return (
		<Tooltip title={t('menu.new_notifications')}>
			<IconButton size="small" color="inherit" sx={{color: 'yellow'}} onClick={props.to_notifications}>
				<NotificationsActiveIcon/>
			</IconButton>
		</Tooltip>
	);
});

const CentralizeButton = observer((props) => {
	const gStorage = useGlobalStorage();

	if (props.followingGps === undefined || props.followingGps === null || !props.centralize_fn || !gStorage.conn.online)
		return null;

	return (<Button color="inherit" disabled={props.followingGps} onClick={props.centralize_fn}><CenterFocusWeakIcon/></Button>);
});

const FilterButton = observer((props) => {
	const gStorage = useGlobalStorage();

	if (!props.enter_filter_fn || !props.filter_is_default || !gStorage.conn.is_auth || !gStorage.conn.online || window.location.pathname !== '/')
		return null;

	const color = props.filter_is_default() ? "inherit" : "#ffeb3b";

	return (
		<IconButton sx={{ color: color }} onClick={props.enter_filter_fn}>
			<FilterListIcon/>
		</IconButton>
	);
});

const ObsCloseButton = ((props) => {
	const gStorage = useGlobalStorage();

	if (!gStorage.conn.is_auth || !props.action)
		return null;

	return (
		<IconButton edge="start" color="inherit" onClick={props.action} aria-label="close">
			<CloseIcon />
		</IconButton>
	);
});

const OfflineButton = observer((props) => {
	const gStorage = useGlobalStorage();

	function enterOnline() {
		if (gStorage.conn.connected) {
			gStorage.conn.setOnline(true, true);
			gStorage.main.setForceLoad(true);
		}
	}

	if (gStorage.conn.online)
		return null;

	if (!gStorage.conn.connected)
		return null;

	if (!gStorage.conn.initialLoginDone)
		return null;

	return (
		<IconButton edge="start" aria-label="offline" sx={{color: 'yellow'}} onClick={enterOnline}>
			<OfflineBoltOutlinedIcon/>
		</IconButton>
	);
});

const MapButton = observer((props) => {
	const gStorage = useGlobalStorage();

	function showMap(e) {
// 		console.log('showMap');

		if (props.enter_map)
			props.enter_map(e);
	}

	if (!gStorage.conn.online || !gStorage.conn.is_auth)
		return null;

	if (window.location.pathname === '/') {
		if (gStorage.conn.offline || !gStorage.main.n_obs ||  gStorage.main.n_obs > LIST_MAP_MAX_ELEM)
			return null;

		return (
			<IconButton edge="start" aria-label="map" onClick={showMap} >
				<MapOutlinedIcon sx={{ color: '#e0e0e0' }}/>
			</IconButton>
		);
	}

	if (window.location.pathname === '/statistics' && (
	    (gStorage.stats.tab === TAB_TIME && [TAB_YEAR, TAB_MONTH, TAB_WINTER].includes(gStorage.stats.time_tab)) ||
	    (gStorage.stats.tab === TAB_LOCATION && [TAB_LOC, TAB_ASSO].includes(gStorage.stats.loc_tab)) || 
	    (gStorage.stats.tab === TAB_SPEC && [TAB_LIFER].includes(gStorage.stats.spec_tab)) || 
	    (gStorage.stats.tab === TAB_OTHER && [TAB_TRIP].includes(gStorage.stats.other_tab)))) {
		if (gStorage.conn.offline || !gStorage.stats.obsList || !gStorage.stats.obsList.length)
			return null;

		return (
			<IconButton edge="start" aria-label="map" onClick={showMap}>
				<MapOutlinedIcon sx={{ color: '#e0e0e0' }}/>
			</IconButton>
		);
	}

	return null;
});

const SumButton = observer((props) => {
	const gStorage = useGlobalStorage();
	const navigate = useNavigate();

	function showSum(e) {
		gStorage.stats.setObsList(null);
		gStorage.stats.setTab(TAB_OBS);

		navigate('/statistics');
	}

	if (!gStorage.conn.online || !gStorage.conn.is_auth)
		return null;

	if (window.location.pathname !== '/')
		return null;

	if (gStorage.conn.offline || !gStorage.main.n_obs ||  gStorage.main.n_obs > LIST_MAP_MAX_ELEM)
		return null;

	return (
		<IconButton edge="start" aria-label="map" onClick={showSum} style={{marginRight: 12}}>
			<FunctionsIcon sx={{ color: '#e0e0e0' }}/>
		</IconButton>
	);
});

const ObsAppBar = observer((props) => {
	const gStorage = useGlobalStorage();
	const navigate = useNavigate();
	
	let bg = gStorage.conn.is_auth && gStorage.conn.user.id === 1 ? 'secondary' : 'primary';

	const to_home = () => navigate("/", { replace: true });
	const to_notifications = () => navigate("/notification_list", { replace: true });

	return (
		<div style={{flexGrow: 1}} id='appbar'>
			<AppBar position="sticky" color={bg} >
				<Toolbar variant="dense" >
					<ObsMenuBtn />
					<Typography variant="h6" style={{flexGrow: 1, textAlign: 'center'}}>{props.getheader ? props.getheader() : ''}</Typography>
					<SumButton {...props} />
					<MapButton {...props} />
					<CentralizeButton {...props} />
					<FilterButton {...props} />
					<ConnLevelButton />
					<OfflineButton />
					<ObsCloseButton action={props.close_action}/>
					<ObsNotificationBtn to_notifications={to_notifications}/>
					<ObsAddBtn action={props.add_action}/>
					<ObsHomeBtn to_home={to_home}/>
				</Toolbar>
			</AppBar>
		</div>
	);
});

export default ObsAppBar;
